import { useQuery } from '@tanstack/react-query'

import { useEncryptionKey } from '@/store'
import decrypt from '@/utils/decrypt'

interface UseDecryptProps {
  ciphertext?: string | null
  enabled?: boolean
  withError?: boolean
}

const useDecrypt = ({
  ciphertext,
  enabled = true,
  withError = false,
}: UseDecryptProps) => {
  const encryptionKey = useEncryptionKey()
  return useQuery({
    queryKey: ['decrypt', ciphertext, encryptionKey],
    queryFn: async () => {
      if (!ciphertext || !encryptionKey) {
        return ''
      }
      return decrypt(ciphertext, encryptionKey, withError)
    },
    enabled: enabled && Boolean(ciphertext) && Boolean(encryptionKey),
    // Since the decryption is deterministic (same input = same output),
    // we can cache the results
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60, // 1 hour
  })
}

export default useDecrypt
